export const components = {
  core: {
    header: {
      home: "Home",
      store: "Store",
      account: "Mein Account",
      login: "Anmelden",
      languageSelect: {
        de: "Deutsch",
        en: "Englisch",
      },
      bookingSelect: {
        default: "Standbuchung wählen",
      },
      avatar: {
        noName: "Nicht definiert",
        noAccount: "Anmelden",
        signout: "Abmelden",
        viewAccount: "Konto ansehen",
        viewMyOrders: "Meine Bestellungen",
        viewMyIncidents: "Meine Serviceanfragen",
        viewMyStandbookingRequests: "Meine Standbuchungsanfragen",
      },
      standSelection: {
        placeholder: "Bitte Standbuchung wählen",
        noStands: "Bitte Stand buchen oder berechtigen lassen",
        standhall: "Halle",
        standnumber: "Stand",
        draft: "(Entwurf)",
      },
    },
    noticeBanner: {
      close: "Hinweis schließen",
      showMore: "Mehr anzeigen",
      showLess: "Weniger anzeigen",
    },
    snackbar: {
      success: {
        default: "Ihre Aktion war erfolgreich.",
        ["productprices/updated"]:
          "Ihr Warenkorb wurde aktualisiert. Bitte prüfen Sie Ihre Bestellung.",
      },
      warning: {
        default:
          "Wir haben Probleme bei der Bearbeitung Ihrer Anfrage. Bitte wenden Sie sich an den Support!",
        ["not/loggedIn"]:
          "Sie sind derzeit nicht eingeloggt! Bitte erstellen Sie ein Konto oder melden Sie sich an.",
        ["account/info/missing"]:
          "Ihr Konto ist noch nicht vollständig! Bitte vervollständigen Sie Ihr Konto.",
        ["invitation/not/found"]:
          "Der Einladungslink ist abgelaufen oder nicht verfügbar.",
      },
      info: {
        default:
          "Wir haben Probleme, Ihnen eine Nachricht zu senden. Bitte wenden Sie sich an den Support!",
      },
      error: {
        default:
          "Etwas ist schief gelaufen. Bitte kontaktieren Sie den Support!",
      },
    },
  },
  common: {
    fields: {
      required: "Das ist ein Pflichtfeld!",
      inputField: {
        numeric: "Die Nummer ist nicht valide!",
        numericMin1: "Ein minimaler Wert von",
        numericMin2: "ist vorgegeben!",
        numericMax1: "Ein maximaler Wert von",
        numericMax2: "ist vorgegeben!",
        email: "Die E-Mail ist nicht valide!",
        zip: "Die Postleitzahl ist nicht valide!",
        houseNumber: "Die Hausnummer ist nicht valide!",
        tel: "Die Nummer ist nicht valide!",
        password: "Das Passwort ist nicht valide!",
        url: "Die URL ist nicht valide!",
      },
      autocomplete: {
        noOptions: "Keine Optionen",
      },
      select: {
        gender: {
          default: "Bitte wählen Sie...",
          male: "Herr",
          female: "Frau",
        },
        title: {
          default: "Bitte wählen Sie...",
          dr: "Dr.",
          prof: "Prof.",
          profDr: "Prof. Dr.",
        },
        department: {
          default: "Bitte wählen Sie...",
          purchasing: "Einkauf",
          marketing: "Marketing",
          press: "Presse / Kommunikation",
          sales: "Vertrieb",
          administration: "Verwaltung",
          management: "Vorstand / Geschäftsführung",
        },
        typeOfOperation: {
          default: "Bitte wählen Sie...",
          manufacturer: "Hersteller",
          retail: "Handel",
          education: "Bildung/Forschung",
          press: "Medien/Presse",
          association: "Verband/Organisationen/Institution",
          serviceProvider: "Dienstleister",
          importer: "Importeur",
          distributor: "Distributor",
          producer: "Erzeuger",
        },
      },
      fileUpload: {
        description: "Ziehen Sie Ihre Datei per Drag & Drop hierher oder",
        button: "Laden Sie eine Datei hoch",
        maxFilesReached: "Sie haben die maximale Anzahl an Dateien erreicht",
        maxFileSizePerFile1: "Maximale Dateigröße: ",
        maxFileSizePerFile2: "MB",
        supportedFileType1: "Unterstütze Dateiformate: ",
        supportedFileType2: ".pdf, .jpg, .jpeg, .png",
        validation: {
          maxFileSize1: "Die Dateigröße ist zu groß. Pro Datei sind maximal",
          maxFileSize2: "MB erlaubt.",
          fileType1: "Dateityp ist nicht zulässig. Es sind nur Dateien vom Typ",
          fileType2: " erlaubt.",
          fileNameAlreadyExists:
            "Eine Datei mit dem selben Namen wurde bereits hochgeladen.",
          tooManyFiles:
            "Die Anzahl der hochgeladenen Dateien wird überschritten.",
        },
      },
    },
    table: {
      searchInput: "Suche",
      pagination: {
        rowsPerPage: "Zeilen pro Seite:",
        paginationPreposition: "von",
      },
    },
    dialog: {
      buttons: {
        cancel: "Abbrechen",
        complete: "Fertig",
      },
    },
  },
}
